import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import facebook from "../../images/facebook.svg";
import instagram from "../../images/instagram.svg";
import tg from "../../images/tg.svg";
import linkdn from "../../images/linkdn.svg";

function Footer() {
  return (
    <section className="footer">
      <Link to="/" className="footer__logo">
        MIKDASH DEVELOPMENT
      </Link>
      <div className="footer__container">
        <Link className="footer__social-link facebook">
          <img src={facebook} alt="facebook" />
        </Link>
        <Link
          to="https://www.instagram.com/mikdashdevelopment?igsh=enNybmxoNjEwNzNq"
          className="footer__social-link instagram"
        >
          <img src={instagram} alt="instagram" />
        </Link>
        <Link className="footer__social-link tg">
          <img src={tg} alt="telegram" />
        </Link>
        <Link className="footer__social-link linkdn">
          <img src={linkdn} alt="linkedin" />
        </Link>
      </div>
    </section>
  );
}

export default Footer;
